import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.default,
  },
  list: {
    backgroundColor: theme.palette.background.paper,
  },
  profit: {
    width: '100%',
  },
  revenue: {
    color: theme.palette.success.light,
  },
}));

export default useStyles;
